import Card from "../components/Card/Card";
import Upload from "../components/Upload/Upload";

const Welcome = () => {
  return (
    <div className="bg-white">
      <Upload />
      <p className="text-white text-3xl font-semibold pt-16 text-center font-serif">
        Welcome onboard
      </p>
      <p className="text-white text-xl font-semibold mt-5 text-center font-serif">
        Here is some useful information to get started!
      </p>
      <div class="flex items-center justify-center p-8 pt-24 gap-y-8 gap-x-32">
        <Card
          title="Contest Submission"
          buttonURL="/submission"
          toolTip="Submit to our list of 12 contests for FREE!"
          img_src="https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
        />
        <Card
          title="Advertisements"
          buttonURL="/ads"
          toolTip="Display your ads in any of the contest and get more streamers on Spotify"
          img_src="https://images.unsplash.com/photo-1503179579247-e6946936f17b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=388&q=80"
        />
        <Card
          title="Skip the Line"
          buttonURL="/skipline"
          toolTip="Don't wanna wait for more than a week to get started? Pay to be among the first to enter a contest!"
          img_src="https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
        />
      </div>
    </div>
  );
};

export default Welcome;
